<template>
  <div class="activeDetail active">
    <van-cell-group class="info">
      <van-cell title="客户名称">
        <p class="item2">{{ traffic.customerName }}</p>
      </van-cell>
      <van-cell title="客户电话">
        <p class="item2">{{ traffic.phone }}</p>
      </van-cell>
      <van-cell title="客户性别">
        <p class="item2">{{ traffic.gender }}</p>
      </van-cell>
      <van-cell title="客户类型">
        <p class="item2">{{ traffic.customerType }}</p>
      </van-cell>
      <van-cell title="客户人数">
        <p class="item2">{{ traffic.visitCnt }}</p>
      </van-cell>
      <van-cell title="到店时间">
        <p class="item2">
          {{ traffic.dateFrom | getTime }} - {{ traffic.dateTo | getTime }}
        </p>
      </van-cell>
      <van-cell title="年龄区间">
        <p class="item2">{{ traffic.estimateAge }}</p>
      </van-cell>
      <van-cell title="所在城市">
        <p class="item2">{{ traffic.provinceName }} {{ traffic.cityName }}</p>
      </van-cell>
      <van-switch-cell
        title="是否试机"
        v-model="traffic.test"
        active-color="#ff4040"
        inactive-color="#000000"
        active-value="1"
        inactive-value="0"
        disabled
      />
      <div v-show="traffic.test === '1'">
        <van-panel title="试机产品">
          <p class="item2 margin-left0_4">{{ traffic.testProducts }}</p>
        </van-panel>
      </div>
      <van-switch-cell
        title="是否购机"
        v-model="traffic.buy"
        active-color="#ff4040"
        inactive-color="#000000"
        active-value="1"
        inactive-value="0"
        disabled
      />
      <div v-show="traffic.buy === '1'">
        <van-panel title="购机产品">
          <p class="item2 margin-left0_4">{{ traffic.buyProduct }}</p>
        </van-panel>
      </div>
      <div v-show="traffic.buy === '0'">
        <van-panel title="未成交原因">
          <p class="item2 margin-left0_4">{{ traffic.reason }}</p>
        </van-panel>
      </div>
      <van-panel title="备注">
        <p class="item2 margin-left0_4">{{ traffic.remark }}</p>
      </van-panel>
    </van-cell-group>

    <van-cell-group class="group" title="系统信息">
      <van-cell title="销售顾问">
        <p class="item2">{{ traffic.salesaman }}</p>
      </van-cell>
      <van-cell title="所属门店">
        <p class="item2">{{ traffic.deptName }}</p>
      </van-cell>
      <van-cell title="创建时间">
        <p class="item2">{{ traffic.createdTime }}</p>
      </van-cell>
    </van-cell-group>
    <div class="bottom-btn flex">
      <!-- <div class="item1 btn sub" @click="cancelView">退出</div> -->
      <div
        class="item1 btn save"
        @click="edit"
        v-if="traffic.status === '0' && viewer === traffic.createdId && hasTrafficModified"
      >
        编辑
      </div>
      <div
        class="item1 btn sub"
        @click="submit"
        v-if="traffic.status === '0' && viewer === traffic.createdId && hasTrafficModified"
      >
        提交
      </div>
    </div>
  </div>
</template>
<script>
import apiActive from "@/api/active";
import moment from "moment";
import $config from "@/config/config";
import campKit from "@/common/campKit";
import imageCompression from "browser-image-compression";

export default {
  data() {
    return {
      id: "",
      traffic: {}, //基本信息
      menuId: "", //菜单ID
      loading: false,
      viewer: null,
      products: [],
      hasTrafficModified: false, // 客户到店流量修改权限
    };
  },
  filters: {
    getTime: function (value) {
      if (!value) {
        return "";
      }
      let formatValue = value.replaceAll("-", "/");
      return new Date(formatValue).Format("hh:mm");
    },
  },
  computed: {},
  watch: {},
  methods: {
    cancelView() {
      this.$router.push({ path: "/customer-traffic" });
    },

    edit() {
      this.$router.push({
        path: "/edit-customer-traffic",
        query: { id: this.traffic.trafficId },
      });
    },
    async submit() {
      if (!this.traffic.customerName) {
        this.$title("请输入客户名称");
        return;
      }
      if (!this.traffic.gender) {
        this.$title("请选择客户性别");
        return;
      }
      if (!this.traffic.customerType) {
        this.$title("请选择客户类别");
        return;
      }
      if (
        this.traffic.visitCnt === "" ||
        !/(^[0-9]\d*$)/.test(this.traffic.visitCnt)
      ) {
        this.$title("请输入客户人数,且客户人数只能为整数");
        return;
      }
      if (!this.traffic.dateFrom || !this.traffic.dateTo) {
        this.$title("请选择到店时间");
        return;
      }
      if (!this.traffic.estimateAge) {
        this.$title("请选择客户年龄区间");
        return;
      }
      if (!this.traffic.province || !this.traffic.city) {
        this.$title("请选择所在城市");
        return;
      }
      if (this.loading) {
        return;
      }
      this.$toast({
        duration: 0,
        mask: true,
        message: "到店信息正在提交中，请稍等...",
      });

      let response = await this.$api.submitCustomerTraffic({
        salesId: this.$wxuserUtil.getUserId(),
        trafficId: this.traffic.trafficId,
      });
      this.loading = false;
      this.$toast.clear();
      if (response.success) {
        this.$title("到店信息提交成功");
        this.cancelView();
      } else {
        this.$title(`到店信息提交失败, ${response.msg}`);
      }
    },
    getDetail(id) {
      let data = {
        salesId: this.$wxuserUtil.getUserId(),
        trafficId: id,
      };
      let response = this.$api.getCustomerTraffic(data);
      if (!response.data) {
        this.$title("该客流信息不存在，即将重定向到到店客流列表页面");
        setTimeout(() => {
          this.cancelView();
        }, 300);
        return;
      }
      let result = response.data;
      this.traffic = {
        trafficId: result.U_TrafficId,
        customerName: result.U_Customer,
        customerType: result.U_Type,
        gender: result.U_Gender,
        visitCnt: result.U_VisitCnt,
        dateFrom: result.U_ArrivalTime_From,
        dateTo: result.U_ArrivalTime_To,
        estimateAge: result.U_EstimateAge,
        province: result.U_Province,
        city: result.U_City,
        provinceName: result.provinceName,
        cityName: result.cityName,
        test: result.U_Test,
        testProducts: result.U_TestProduct,
        buy: result.U_Buy,
        buyProduct: result.U_BuyProduct,
        reason: result.U_Reason,
        remark: result.U_Remark,
        status: result.U_Status,
        phone: result.U_Phone,
        createdTime: result.U_CreatedTime,
        createdId: result.U_CreatedId,
        salesaman: result.advisor,
        deptName: result.depName,
      };
      this.traffic.testProducts = result.U_TestProduct
        ? result.U_TestProduct.split(";")
            .map((u) => {
              return this.products[u] ? this.products[u] : u;
            })
            .join(";")
        : "";
      this.traffic.buyProduct = result.U_BuyProduct
        ? result.U_BuyProduct.split(";")
            .map((u) => {
              return this.products[u] ? this.products[u] : u;
            })
            .join(";")
        : "";
    },
    async queryDictionary() {
      try {
        let response = await this.$api.get("api/dict/queryDict", {
          tcodes: "Test_BuyProduct",
        });
        console.log("dict: ", response);
        let products = response.data["Test_BuyProduct"];
        products.forEach((p) => {
          this.products[p.value] = p.name;
        });
      } catch (error) {
        console.log("dict error: ", error);
        this.$title("发生错误!");
      }
    },
  },
  mounted() {
    // 检查客户到店流量修改权限
    this.hasTrafficModified = this.$wxuserUtil.hasFunAuthByRouteInst(this.$route, this.$funcKey.TrafficModified);
  },
  async created() {
    await this.queryDictionary();
    if (this.$route.query.id) {
      this.getDetail(this.$route.query.id);
    }
    this.viewer = this.$wxuserUtil.getUserId();
  },
};
</script>
<style scoped lang="less" rel="stylesheet/less">
// @import "../../../style/pageStyle/pageView-activeDetail.less";
.van-cell__label {
  word-break: break-all;
}
.activeDetail {
  padding-bottom: 55px;
}
.step-img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  margin: 5px;
}
.steps {
  margin: 10px 15px;
  .step {
    padding: 10px 15px;
    position: relative;
    .step-icon {
      position: absolute;
      top: 10px;
      left: -10px;
      z-index: 2;
    }
  }
  .step:not(:last-child):after {
    content: "";
    position: absolute;
    left: 0px;
    width: 0;
    height: 100%;
    top: 15px;
    border-left: 1px solid #f2f2f2;
  }
}
.qrcode {
  text-align: center;
  img {
    width: 60%;
  }
}
.list-card {
  margin: 20px 10px;
  background-color: #fff;
  padding: 10px;
  position: relative;
  border: 1px solid #f2f2f2;
  border-radius: 20px;
}
.get-work {
  color: #ffa014;
}
.group {
  margin-top: 10px;
}

.bottom-btn {
  height: 46px;
  line-height: 46px;
  text-align: center;
  font-size: 15px;
  color: #fff;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
}
.bottom-btn .save {
  background-color: #222;
}
.bottom-btn .sub {
  background-color: #e10913;
}
.margin-left0_4 {
  margin-left: 0.4rem;
}
.van-cell__title {
  color: #969799;
}
.van-cell__value {
  color: #323233;
}
</style>



// WEBPACK FOOTER //
// src/components/client/childCompoents/viewCustomerTraffic.vue